/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, nthChildIterator, mediaQuery, disable } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : EMBEDS : LIBRARY : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	library: {
		width: '100%',

		// ..... ROW GROUPS ..... //
		'& .libraryelement': {
        	textAlign: 'left',
			'&.library-content': {
				position: 'relative',
				'& .title.name-numberof': {
					opacity: '0',
					animationName: 'fadeInUp',
					animationDelay: '.3s',
					animationDuration: '.2s',
					animationFillMode: 'forwards'
				}
			},
			'&.library-controls': {
				'& .name-nameTitle':{
					'& .selected':{
						fontSize: pxToEm(14)
					}
				},
			}
		},

		// ..... EMBEDS ..... //
		'& .embeds': {
			width: '100%',
			// overflow: 'hidden',
			display: 'flex',
			flexWrap: 'wrap',
			alignItems: 'flex-start', // stretch
			justifyContent: 'flex-start',
			'& .embedcard': {
				marginRight: '0.65%',
				marginLeft: '0.65%',
				marginBottom: pxToEm(20),
				width: '32%',
				transition: 'all .2s linear 0s',

				// animate in
				opacity: '0',
				animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
				extend: nthChildIterator(100, .3, .05),
			},
			'& .newembed': {
				// animate in
				opacity: '0',
				animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationDelay: '.25s',
                animationFillMode: 'forwards',

				cursor: 'pointer',
				background: '#FAFBFC',
				borderRadius: pxToEm(5),
				border: replacePXinStringWithEM(`3px dashed #ECF0F7`),
				minWidth: pxToEm(150),
				width: '32%',
				marginRight: '0.65%',
				marginLeft: '0.65%',
				marginBottom: pxToEm(20),
				minHeight: pxToEm(350),
				display: 'flex',
				flexDirection: 'column',
				alignContent: 'center',
				alignItems: 'center',
				justifyContent: 'center',
				transition: 'all .2s linear 0s',
				alignSelf: 'stretch',
				'& .icon': {
					color: 'rgba(6, 43, 117, 0.5)',
					fontSize: '250%'
				},
				'& .text': {
					color: 'rgba(6, 43, 117, 0.5)',
					fontSize: pxToEm(16)
				},
                '&.disabled-true':{
                    extend: disable,
                    filter: `grayscale(1) opacity(0.45)`
                },
				'&:hover': {
					filter: 'brightness(95%)'
				}
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	// [mediaQuery.medium]: {
	// 	library: {
	// 		// ..... CONTROLBAR ..... //
	// 		'& .controlbar': {
	// 			display: 'flex',
	// 			flexDirection: 'column',
	// 			marginBottom: pxToEm(30),
	// 			'& .searchbar': {
	// 				maxWidth: '100%',
	// 				width: '100%',
	// 				marginBottom: pxToEm(15)
	// 			}
	// 		}
	// 	}
	// },
	[mediaQuery.thinnest]: { 
		library: {
			'& .embeds': {
				'& .embedcard, .newembed': {
					width: '100%',
					marginRight: '0 !important',
					height: pxToEm(350)
				}
			}
		}
	}
});